import React from 'react';
import Section from '../../elements/Section';
import styles from './style.module.css';

export const ContainerRegisterVehicle = ({ ...props }) => {
  return <Section className={styles.mcv} mx="auto" width={1} {...props} />;
};
